module.exports = flarum.core.compat['common/app'];